export default {
  get: {
    getCaptcha: "/apiApp/captcha",

    getSosIndexList: "/apiApp/getSosIndexList",

    getDateTimeList: "/apiApp/getDateTimeList",
    /** 获得指数滞销列表 */
    getUnsalabeIndexList: "/apiApp/getUnsalabeIndexList",

    getRegisterCity: "/apiApp/getRegisterCity",
     /** 获取新闻列表 */
     getNewsList: "/apiApp/getNewsList",
     /** 获取新闻分类 */
     getNewsTags: "/apiApp/getNewsTags",
      /** 获取新闻详情 */
      getNewsDetail: "/apiApp/getNewsDetail",
      getHomePageNews:"/apiApp/getHomePageNews",
      getConcatPhone:"/apiApp/getConcatPhone", // 官网热线
      getWelfareList:"/apiApp/gongyi/querynew"
  },
  post: {
    /** 提交反馈 */
    commitFeedback: "/apiApp/feedback",

    createDriver: "/apiApp/createDrivers",

    createCityPartner: "/apiApp/createCityPartner",

    createCountyPartner: "/apiApp/createCountyPartner",
    /** 创建滞销 */
    createUnsalables: "/apiApp/createUnsalables",
    /** 上传图片 */
    profile: "/apiApp/profile",
  }
};
